import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { CreateUser, EditUser, Users } from './pages';

export const UsersEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Users',
      element: <Users />,
      path: '/',
    },
    {
      label: 'Create User',
      element: <CreateUser />,
      path: '/new',
    },
    {
      label: 'Edit User',
      element: <EditUser />,
      path: '/:id/edit',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
